<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-chart-line`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.04199 1.74219C2.40925 1.7422 2.70703 2.03997 2.70703 2.40723V12.9287H13.959C14.326 12.929 14.624 13.2266 14.624 13.5938C14.6237 13.9606 14.3259 14.2576 13.959 14.2578H2.04199C1.67491 14.2578 1.37725 13.9608 1.37695 13.5938V2.40723C1.37695 2.03996 1.67472 1.74219 2.04199 1.74219ZM12.916 4.75977C13.1755 4.50024 13.5967 4.50057 13.8564 4.75977C14.1161 5.01946 14.1161 5.44147 13.8564 5.70117L10.374 9.18359C10.1143 9.44317 9.69325 9.44325 9.43359 9.18359L7.76562 7.5166L5.07031 10.2129C4.8106 10.4725 4.38857 10.4726 4.12891 10.2129C3.86962 9.95327 3.86962 9.53208 4.12891 9.27246L7.2959 6.10645L7.40039 6.02051C7.65848 5.85027 8.00917 5.8793 8.23633 6.10645L9.90332 7.77246L12.916 4.75977Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineChartLine',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
